import { EVENT_DELAY } from '@src/config/constants'
import { MODULES, FEATURES } from '@src/quince-site-common/src/constants/template-info'
import { captureFatalException } from '@src/quince-site-common/src/utils/sentryUtil'
import { handleSgtmApi } from '@src/telemetry/handleSgtmApi'
import { getStorefrontIdProperty } from '@src/utils/b2b'
import { executeFireAndForgotTask } from '@src/utils/fire-and-forgot-task'

import { isBotAgent } from '../mixpanel/mixpanel.helper'

const trackPixelWithSGTM = (properties: any, shouldProcessResponseHeaders = false) => {
  executeFireAndForgotTask(() => {
    try {
      if (!isBotAgent()) {
        handleSgtmApi(
          {
            ...properties,
            ...getStorefrontIdProperty(), //storefront_id is used to identify the b2b self serve flow
          },
          'server_pixel_sgtm_api',
          'server_pixel_properties',
          shouldProcessResponseHeaders,
        )
      }
    } catch (err) {
      captureFatalException(`Failed to track event with pixel through sgtm: ${JSON.stringify(err)}`, {
        module: MODULES.SERVER_PIXEL,
        feature: FEATURES.SERVER_PIXEL_API,
      })
    }
  }, EVENT_DELAY)
}

export { trackPixelWithSGTM }
